<template>
  <b-nav-item
    :title="title"
    :disabled="disabled"
    link-classes="p-1"
    @click="$emit('click')"
  >
    <font-awesome-icon
      :icon="$icon"
      :size="iconSize"
      :color="color"
      :spin="$icon==='spinner'"
    />
  </b-nav-item>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { ButtonStates, ButtonState } from '@/types'

const props = {
  title: {
    type: String,
    default: '',
  },
  disabled: Boolean,
  icon: {
    type: [String, Array],
    default: '',
  },
  iconSize: {
    type: String,
    default: 'lg',
  },
  buttonState: {
    type: Number as PropType<ButtonState>,
    default: ButtonStates.ICON,
  },
}

@Component
export default class BuilderBtnItem extends Vue.extend({ props }) {
  get icons () {
    return [
      { id: ButtonStates.ICON, icon: this.icon },
      { id: ButtonStates.PROCESSING, icon: 'spinner' },
      { id: ButtonStates.SUCCESS, icon: 'check-circle', color: 'green' },
      { id: ButtonStates.FAILURE, icon: 'times-circle', color: 'red' },
    ]
  }

  get $icon () {
    return this.icons.find(i => i.id === this.buttonState)?.icon
  }

  get color () {
    return this.icons.find(i => i.id === this.buttonState)?.color
  }
}

</script>
